//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectRoomModal from '../components/select-room-modal';
import SelectOwnerModal from '../components/select-owner-modal';
import SelectProjectModal from '../components/select-project-modal';

export default {
    name: 'ownerEdit',
    components: { SelectOwnerModal, SelectRoomModal, SelectProjectModal },
    data() {
        const vm = this;
        return {
            id: 0,
            loading: false,
            title: '新增业主信息',
            ownerInfo: {
                purchaseAmount: 0,
                projectName: '',
                cardType: 0,
                room: {}
            },
            saving: false,
            showAddRoomModal: false,
            showAddMemberModal: false,
            rules: {
                // roomNumber: [{ required: true, message: '不能为空', trigger: 'blur' }],
                // name: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
                // phoneNumber: [{ required: true, message: '请输入客户手机号', trigger: 'blur' }],
                // cardType: [{ required: true, type: 'number', message: '不能为空', trigger: 'change' }],
                // cardNum: [{ required: true, message: '不能为空', trigger: 'blur' }],
                // purchaseAmount: [{ required: true, type: 'number', message: '不能为空', trigger: 'blur' }],
                // purchaseDate: [{ required: true, type: 'date', message: '不能为空', trigger: 'change' }],
                projectName: [{ required: true, message: '请选择项目', trigger: 'blur' }]
                // projectStages: [{ required: true, message: '请输入分期名称', trigger: 'blur' }],
                // roomStructureName: [{ required: true, message: '请输入楼栋号', trigger: 'blur' }],
                // chamberName: [{ required: true, message: '请输入单元号', trigger: 'blur' }],
                // storeyName: [{ required: true, message: '请输入楼层', trigger: 'blur' }],
                // roomNumber: [{ required: true, message: '请输入房号', trigger: 'blur' }]
            },
            showAddProjectModal: false
        };
    },
    methods: {
        onSave() {
            console.log(this.ownerInfo);
            const vm = this;
            this.$refs.ownerInfoForm.validate(async val => {
                if (val) {
                    vm.saving = true;
                    // vm.ownerInfo.receiveDate = vm.ownerInfo.receiveDate.toLocaleDateString();
                    // vm.ownerInfo.purchaseDate = vm.ownerInfo.purchaseDate != null ? vm.ownerInfo.purchaseDate.toLocaleDateString() : '';
                    // vm.ownerInfo.deliverStartDate = vm.ownerInfo.deliverStartDate != null ? vm.ownerInfo.deliverStartDate.toLocaleDateString() : '';
                    // vm.ownerInfo.deliveryDate = vm.ownerInfo.deliveryDate != null ? vm.ownerInfo.deliveryDate.toLocaleDateString() : '';
                    // vm.ownerInfo.receiveDate = vm.ownerInfo.receiveDate != null ? vm.ownerInfo.receiveDate.toLocaleDateString() : '';
                    // vm.ownerInfo.issueDate = vm.ownerInfo.issueDate != null ? vm.ownerInfo.issueDate.toLocaleDateString() : '';
                    abp.ajax.post('/api/services/app/Owner/SaveOwner', vm.ownerInfo).then(res => {
                        // vm.showRoomModal = false;
                        // vm.getPage();
                        // vm.$router.push({ path: '/project/owners' });
                        vm.$router.push({ name: 'ownerDetail', params: { id: res.data.result } });

                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },
        showAddRoom() {
            this.showAddRoomModal = true;
        },
        addRoom(data) {
            console.log(data);
            this.ownerInfo.projectId = data.projectId;
            this.ownerInfo.roomId = data.id;
            this.ownerInfo.roomNumber = data.roomNumber;
            this.showAddRoomModal = false;
        },
        showAddMember() {
            this.showAddMemberModal = true;
        },
        addOwner(data) {
            console.log(data);
            // this.ownerInfo.projectId = data.projectId;
            this.ownerInfo.memberId = data.id;
            this.ownerInfo.ownerName = data.name;
            this.showAddMemberModal = false;
        },
        getOwnerById() {
            if (this.id === 0) {
                return;
            }
            const vm = this;
            vm.loading = true;
            abp.ajax.get('/api/services/app/Owner/GetOwnerById?id=' + this.id).then(res => {
                vm.ownerInfo = {
                    room: {}
                };
                vm.ownerInfo = res.data.result;
            }).finally(() => {
                vm.loading = false;
            });
        },
        showAddProject() {
            this.showAddProjectModal = true;
        },
        addProject(data) {
            // console.log(data);
            const vm = this;
            vm.ownerInfo.projectId = data.id;
            vm.ownerInfo.projectName = data.name;
            vm.ownerInfo.room.projectName = data.name;
            vm.ownerInfo.room.projectId = data.id;
            vm.showAddProjectModal = false;
        },
        purchaseDateChange(date) {
            this.ownerInfo.purchaseDate = date;
        },
        deliverStartDateChange(date) {
            this.ownerInfo.deliverStartDate = date;
        },
        deliveryDateChange(date) {
            this.ownerInfo.deliveryDate = date;
        },
        issueDateChange(date) {
            this.ownerInfo.issueDate = date;
        },
        receiveDateChange(date) {
            this.ownerInfo.receiveDate = date;
        },
        dataTransferTimeChange(date) {
            this.ownerInfo.dataTransferTime = date;
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.title = '编辑业主信息';
            this.getOwnerById();
        } else {
            this.title = '新增业主信息';
        }
    },
    watch: {
        // '$route'(to, from) {
        //     // data数据操作
        //     if (to.name === 'ownerEdit') {
        //         // this.activityId = parseInt(this.$route.params.id || 0);
        //         this.id = parseInt(this.$route.params.id) || 0;
        //         this.ownerInfo = {
        //             purchaseAmount: 0
        //         };
        //     }
        // }
    }
};
